module.exports = __webpack_public_path__ + "img/2x.e826fa1.jpg";